import { APIUrl, APIUrlNode } from "./config";
export default {
  contritycode: `${APIUrl}/agt/countries`,
  verificationCode: `${APIUrl}/agt/v1/verificationCode`, //获取手机验证码
  login: `${APIUrl}/agt/login`, //登陆
  logout: `${APIUrl}/agt/v1/logout`, //退出登陆
  account: `${APIUrl}/agt/v1/account`, //账号信息
  charge4user: `${APIUrl}/agt/charge/agent/charge4user`, //充值
  disburse: `${APIUrl}/agt/v1/trade/disburse`, //新充值
  disburse_amount: `${APIUrl}/agt/v1/trade/disburse-amount`, //新充值 自定义数量
  catalogs: `${APIUrl}/agt/v1/trade/disburse/catalogs`, //充值项
  trade_record: `${APIUrl}/agt/v1/trade/records`, //账号变动记录
  // trade_record: `${APIUrl}/agt/charge/agent/trade_record`, //代理商账号变动记录接口
  // trade_record_official: `${APIUrl}/agt/charge/agent/trade_record/admin`, //代理商账号变动记录接口
  get_user: `${APIUrl}/agt/v1/user`, //通过uid 获取用户信息
  host_statistic: `${APIUrl}/agt/v1/family/statistics`,
  daily_rank: `${APIUrl}/agt/v1/family/host/rank`,
  rank_detail: `${APIUrl}/agt/v1/family/host/rank/detail`,
  export: `${APIUrl}/agt/base/agent/query_family_stat_export`,
  recharge: `${APIUrl}/agt/charge/agent/recharge`,
  recharge_list:`${APIUrl}/agt/v1/trade/recharge/catalogs`,
  recharge_r:`${APIUrl}/agt/v1/trade/recharge`,
  node_login: `${APIUrlNode}/agent/login`,
  node_code: `${APIUrlNode}/agent/code`,
  node_login_code: `${APIUrlNode}/agent/phoneCode/login`,
  node_reset: `${APIUrlNode}/agent/reset`
};
// export default {
//   verificationCode: `/api/verificationCode`, //获取手机验证码
//   login: `/api/login`, //登陆
//   logout: `/api/logout`, //退出登陆
//   account: `/api/charge/agent/account`, //账号信息
//   charge4user: `/api/charge/agent/charge4user`, //充值
//   trade_record: `/api/charge/agent/trade_record`, //代理商账号变动记录接口
//   get_user: `/api/base/agent/get_user`, //通过uid 获取用户信息
//   host_statistic: `/api/base/agent/query_family_stat`,
//   daily_rank: `/api/base/agent/list_host_rank`,
//   rank_detail: `/api/base/agent/list_host_user_rank`,
//   export: `/api/base/agent/query_family_stat_export`,
//   recharge: `/api/charge/agent/recharge`,
//   node_login: `${APIUrlNode}/agent/login`,
//   node_code: `${APIUrlNode}/agent/code`,
//   node_login_code: `${APIUrlNode}/agent/phoneCode/login`,
//   node_reset: `${APIUrlNode}/agent/reset`,
// };



// WEBPACK FOOTER //
// ./src/api/api_config.js